import {
  View,
  Text,
  Pressable,
  StyleSheet,
  TextInput,
  Dimensions,
  Image,
  Platform,
} from 'react-native';
import { BottomSheetModal, BottomSheetView } from '../components/BottomSheet';
import type { BottomSheetModalRef } from '../components/BottomSheet';
import { useMemo } from 'react';
import { UserSessionAttributes } from '../models/user-session-model';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { clearSession } from '../store/actions/user-session';
import AsyncStorage from '@react-native-async-storage/async-storage';

const { width } = Dimensions.get('window');

interface SignOutOptionsProps {
  navigation: any;
  bottomSheetModalRef: React.RefObject<BottomSheetModalRef>;
  destination: string;
}

const SignOutOptions: React.FC<SignOutOptionsProps> = ({ navigation, bottomSheetModalRef, destination }) => {
  const userSession: UserSessionAttributes | undefined = useSelector(
    (state: RootState) => state.user.session
  );

  const dispatch: AppDispatch = useDispatch();
  
  const snapPoints = useMemo(() => ['35%'], []);

  const handleLogout = async () => {
    CloseBottomSheet();
    dispatch(clearSession(userSession));

    await AsyncStorage.clear();

    const getToken = await AsyncStorage.getItem('token');

    navigation.navigate(destination, {
      token: getToken,
    });
  };

  const CloseBottomSheet = () => {
    bottomSheetModalRef.current?.dismiss();
  };

  return (
    <BottomSheetModal
      ref={bottomSheetModalRef}
      index={0}
      snapPoints={snapPoints}
      enablePanDownToClose={true}
      backgroundStyle={{
        borderRadius: 30,
        backgroundColor: '#1A1D21',
      }}
      handleIndicatorStyle={{
        backgroundColor: 'transparent',
        width: 0,
        height: 0,
      }}
      style={Platform.OS === 'web' ? {
        maxWidth: 430,
        marginLeft: 'auto',
        marginRight: 'auto',
      } : {}}
    >
      <BottomSheetView style={{ paddingBottom: 40 }}>
        <View style={{ marginTop: -8 }}>
          <View style={{ flex: 1, alignItems: 'center' }}>
            <Image
              source={require('../../assets/headerBarIcon.png')}
              style={{ width: 55, height: 5, marginTop: 20 }}
            />
          </View>
          <View className="p-4" style={{ paddingTop: 20 }}>
          <Text className="text-2xl font-bold text-center text-white">
            Logout
          </Text>

          <View style={styles.line} className="my-4" />
          <Text
            className="text-base font-normal text-center"
            style={styles.textColor}
          >
            Are you sure you want to logout?
          </Text>
          <View className="flex flex-row justify-between items-center px-6 py-3">
            <Pressable
              style={[styles.cancelButton]}
              onPress={CloseBottomSheet}
            >
              <Text className="px-8 py-3 text-xs font-semibold text-white">
                Cancel
              </Text>
            </Pressable>
            <Pressable style={[styles.logoutButton]} onPress={handleLogout}>
              <Text className="px-8 py-3 text-xs font-semibold text-white">
                Yes, Logout
              </Text>
            </Pressable>
          </View>
          </View>
        </View>
      </BottomSheetView>
    </BottomSheetModal>
  );
};

const styles = StyleSheet.create({
  containerBgColor: {
    backgroundColor: '#1A1D21',
  },
  bgColor: {
    backgroundColor: '#F75555',
  },
  textColor: {
    color: '#8D8E90',
  },
  line: Platform.select({
    web: {
      borderBottomColor: '#636363',
      borderBottomWidth: 1,
      borderStyle: 'dashed',
    },
    default: {
      borderBottomColor: '#636363',
      borderBottomWidth: 1,
    },
  }),
  cancelButton: {
    borderWidth: 1,
    borderColor: '#FFFFFF',
    borderRadius: 20,
  },
  logoutButton: {
    backgroundColor: '#F75555',
    borderRadius: 20,
  },
});

export default SignOutOptions;
